// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-4bbc6c2a]{border-radius:.25rem;cursor:pointer;overflow:hidden;position:relative;transition-duration:.15s;-webkit-user-select:none;-moz-user-select:none;user-select:none}.card__image[data-v-4bbc6c2a]{display:block;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;transition-duration:.15s;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
